import type { FaireProductEntity } from "../../entity_types/product";

export const p_frcdq9ukhw: FaireProductEntity = {
  token: "p_frcdq9ukhw",
  type: "product",
  name: "Alligator Hard Day Encouragement Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ff48539950dd05bd0e1b32a267a582a00ef4ca66b74885778cedf48f4837ea81.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12a75a90856ada9f37648ca56d505b47e9be5cb9b53f7ad12fe2c952ad013373.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:18.720Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
